import { EnterNewPhoneTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const EnterNewPhoneTrackingSchema: Record<
  EnterNewPhoneTrackingPoint,
  string
> = {
  [EnterNewPhoneTrackingPoint.PageView]: '792f1e5d-6abc-4852-b0f1-6692b3991c82',
  [EnterNewPhoneTrackingPoint.NextButtonClick]:
    'a5a155de-5f22-4b96-ad81-fd12de6e72ee',
  [EnterNewPhoneTrackingPoint.BackButtonClick]:
    '41246dee-50d8-4520-8744-76be60163bad',
  [EnterNewPhoneTrackingPoint.HelpButtonClick]:
    'a1d373fe-5d76-4736-aa31-41929546e828',
  [EnterNewPhoneTrackingPoint.EnterNewPhoneSuccessAction]:
    'f5b5cf20-e461-431c-bc39-61d6745f478e',
  [EnterNewPhoneTrackingPoint.EnterNewPhoneFailAction]:
    '5bde3558-b131-47bd-be04-61fe6b5cd0df',
};

export const getEnterNewPhonePageTypeAndSchema = (
  trackingPoint: EnterNewPhoneTrackingPoint
) => {
  return {
    page_type: PageType.EnterNewPhonePage,
    schema: EnterNewPhoneTrackingSchema[trackingPoint],
  };
};
